import React from "react";
import ZipcodeModal from "./ZipcodeModal";
import ByeLausanneModal from "./ByeLausanneModal";
import LoginModal from "./LoginModal";
import NewUserPromoModal from "./NewUserPromoModal";
import AlsoBoughtModal from "./AlsoBoughtModal";
import UnavailableProductsModal from "./UnavailableProductsModal";

const FarmyModalsBlock = () => {
  return <>
    <ByeLausanneModal/>
    <LoginModal/>
    <ZipcodeModal/>
    <NewUserPromoModal/>
    <AlsoBoughtModal/>
    <UnavailableProductsModal/>
  </>;
};

export default FarmyModalsBlock;
